import r from"./_coreJsData.js";var e,a=r,o=(e=/[^.]+$/.exec(a&&a.keys&&a.keys.IE_PROTO||""))?"Symbol(src)_1."+e:"";var s=function(r){return!!o&&o in r};export{s as default};
//# sourceMappingURL=_isMasked.js.map
